export default "__VITE_ASSET__CaKVB2Bu__"